@if (routeDataService.routeData().canTranslate) {
  <p-menu #menu [model]="items()" [popup]="true" appendTo="body">
    <ng-template #item let-item>
      <a pRipple class="flex items-center p-menu-item-link" [href]="item.url">
        <img src="https://hatscripts.github.io/circle-flags/flags/{{item.flag}}.svg" width="24" height="24"
             [alt]="item.label"/>
        <span class="ml-2">{{ item.label }}</span>
      </a>
    </ng-template>
  </p-menu>

  <p-button (click)="menu.toggle($event)" text size="small" severity="contrast" [ngClass]="{'medium-thin:hidden': location() === 'header'}">
    @if (translateService.language() === 'en') {
      <img src="https://hatscripts.github.io/circle-flags/flags/{{'us'}}.svg" width="24" height="24"
           alt="English (US)"/>
      EN
    } @else {
      <img src="https://hatscripts.github.io/circle-flags/flags/{{'mx'}}.svg" width="24" height="24"
           alt="Español"/>
      ES
    }
  </p-button>

  <!-- No-JS fallback (static links so crawlers & JS-off users see them) -->
  <div class="sr-only">
    <div class="item-row" style="padding:.5rem .75rem;">
      <a [href]="translateService.enUrl()" hreflang="en">
        English
      </a>
    </div>
    <div class="item-row" style="padding:.5rem .75rem;">
      <a [href]="translateService.esUrl()" hreflang="es">
        Español
      </a>
    </div>
  </div>
}
